// extracted by mini-css-extract-plugin
export var body = "text-3d-module--body--af27e";
export var container = "text-3d-module--container--a8610";
export var primary = "text-3d-module--primary--75c8e";
export var secondary = "text-3d-module--secondary--1250f";
export var textContainer = "text-3d-module--textContainer--c6c8d";